module.exports = __webpack_public_path__ + "9f53196135a7753858d696e67b8bf6c7.svg";